__turbopack_context__.v({
  "h2": "StyleConstants-module__AbvbmG__h2",
  "p": "StyleConstants-module__AbvbmG__p",
  "sectionPadding": "StyleConstants-module__AbvbmG__sectionPadding",
});
